import React from 'react';
import '../styles/Navbar.scss';
import { useNavigate } from 'react-router-dom';
import ThemeSwitch from './ThemeSwitch';

const Navbar = ({ isAuthenticated, onLogout, userName, isStaff }) => {
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => navigate('/')}>
          <img className="logo-light" src="/assets/govflow-stacked-colour.png" alt="GovFlow - The way Governance should flow" />
          <img className="logo-dark" src="/assets/govflow-stacked-white.png" alt="" aria-hidden="true" />
        </div>
        <div className="navbar-menu">
          {isAuthenticated ? (
            <>
              <ThemeSwitch />
              <span className="navbar-user">Welcome, {userName}</span>
              <button className="navbar-link" onClick={() => navigate('/select-context')}>
                View all Companies
              </button>
              {isStaff && (
                <button className="navbar-link" onClick={() => navigate('/admin/templates')}>
                  Templates
                </button>
              )}
              <button className="navbar-link" onClick={() => navigate('/profile')}>
                Profile
              </button>
              <button className="navbar-link" onClick={onLogout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <button className="navbar-link" onClick={() => navigate('/login')}>
                Login
              </button>
              <button className="navbar-link" onClick={() => navigate('/register')}>
                Register
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
